import fetch from 'isomorphic-fetch'
import { IOption } from '../types'
import { memoize } from 'lodash-es'
import { fetchGraphQL } from './GraphQLService'

// Atom services return in this format
export type AsyncProfession = {
  Description: string
  Id: number
}

export type AsyncProfessionList = AsyncProfession[]


/**
 * ListResults pulls the initial list of options displayed to app search user
 */
export class ListResults {
  private primed: boolean
  private cache: IOption[]
  private preselect: { industry: false | string }
  private brandCode: string

  constructor(
    preselect: { industry: false | string },
    brandCode: string
  ) {

    this.cache = []
    this.primed = false
    this.preselect = preselect
    this.brandCode = brandCode

  }

  fetch(): Promise<IOption[]> {
    return this.cache.length > 0
      ? Promise.resolve(this.cache)
      : this.fetchFromService()
  }

  private async fetchFromService(): Promise<IOption[]> {
    try {
      // console.log('[Atom Results] fetch list from Atom')

      // get the set of preselected profession IDs
      if (this.preselect.industry) {
          this.cache = await this.fetchProfessions(this.brandCode, this.preselect.industry)
      }

      if (this.cache.length === 0 && !this.preselect.industry) {
        this.cache = await this.fetchProfessions(this.brandCode)
      }

      return this.cache
    } catch (err) {
      console.log('Unable to fetch initial results from Atom')
      console.log(err)
    }
    return []
  }

  fetchProfessions: (brandCode: string, industry?: string) => 
    Promise<IOption[]> = async (brandCode: string, industry?: string) => {
      console.log('[List Results] fetch professions')
      const response = await fetchGraphQL(brandCode, "", industry || "")
      if (response === null){
        throw Error("[ProfessionSearch] - A call to retrieve the initial list failed.")
      } else {
        console.log(response)
      }
  
      const gqlResults = response.professions?.results ?? []
      const atomResult: AsyncProfessionList = gqlResults.map(gqlItem => {
        return {
          Description: gqlItem.professionName,        // old "Description" field
          Id: parseInt(gqlItem.businessClassId, 10),  // old "Id" as number
        }
      })
      return this.processList(atomResult.map(resultToOption))
  }

  primeCache() {
    if (this.primed === false) {
      this.primed = true
      this.fetch()
    }
  }

  // if the first option of the list is abortion, remove it
  private processList(list: IOption[]) {
    if (list.length > 0 && list[0].label.indexOf('Abortion') > -1) {
      return list.slice(1)
    }
    return list
  }
}

// treating this as a singleton for now
type ListResultsInstance = false | ListResults

let listResultsInstance: ListResultsInstance = false

export function getListResults(
  brandCode: string,
  preselect: { industry: false | string }
): ListResults {
  if (listResultsInstance === false) {
    listResultsInstance = new ListResults(
      preselect,
      brandCode
    )
  }

  return listResultsInstance
}

// adapt to the "Option" shape expected by react-select
export function resultToOption(profession: AsyncProfession): IOption {
  return {
    label: profession.Description,
    value: profession.Id,
  }
}
